import * as React from 'react';
export const warningSvg = React.forwardRef(function warningSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm10.461 1.705 4.918 8.941a3 3 0 0 1 .371 1.446v.658a3 3 0 0 1-3 3h-9.5a3 3 0 0 1-3-3v-.658a3 3 0 0 1 .371-1.446l4.918-8.94a2.809 2.809 0 0 1 4.922 0ZM12.75 14.25h-9.5a1.5 1.5 0 0 1-1.5-1.5v-.658a1.5 1.5 0 0 1 .186-.723l4.917-8.941a1.309 1.309 0 0 1 2.294 0l4.917 8.941a1.5 1.5 0 0 1 .186.723v.658a1.5 1.5 0 0 1-1.5 1.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.25 11.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM7 5.499c-.029-.543.456-.999 1-.999s1.029.456 1 .999L8.79 8.5a.79.79 0 0 1-1.58 0L7 5.5Z',
    }),
  );
});
warningSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var warning = {
  category: 'icon',
  colorable: true,
  name: 'warning',
  svg: warningSvg,
};
